export const INFLUENCER_APP_IOS_LINK = 'https://itunes.apple.com/us/app/collabary-influencer-app/id1252570939?mt=8';
export const INFLUENCER_APP_ANDROID_LINK = 'https://play.google.com/store/apps/details?id=com.collabary.influencer';

export type AvailableMobilePlatforms = 'ios' | 'android';

export function getPlatform(): AvailableMobilePlatforms | null {
  if (/iPhone/.test(window.navigator.userAgent)) {
    return 'ios';
  }

  if (/Android/.test(window.navigator.userAgent)) {
    return 'android';
  }

  return null;
}

export function isLessThanDesktop() {
  const width = window.innerWidth;

  return width > 0 && width < 1200;
}
